module.exports = __webpack_public_path__ + "media/images/common/header_bg-c50619c0069acf1c64e2d8e0e22d47e5.png";